window._ = require('lodash');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    console.log(error);
    if ((error.response.status) && ([401, 402, 403].includes(error.response.status))) {
        alert(error.response.data.message);
    }
    return Promise.reject(error);
});
window.Vue = require('vue').default;

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

import {modelManagerServicesMixin} from './components/mixins/modelManagerServicesMixin.js';
import ReactiveProvide from 'vue-reactive-provide'
window.Vue.use(ReactiveProvide)
var app = new Vue({
    el: '#app',
    mixins: [modelManagerServicesMixin, ReactiveProvide],
    data: function() {
        return {
            testarray: [],
            testobject: {},
            testinteger: 0,
            teststring: '',
        }
    }
})

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
